"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import Icon2Bars from "@/app/(components)/generics/Icons/Icon2Bars";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { HomeCtaAction } from "@/app/types/common/HomeCtaAction";
import { CallToCTAKeys } from "@/app/types/home/CallToCTAKeys";
import { UStyles } from "@/app/utils/UStyles";
import { Globals } from "@/app/vars/Globals";
import homeStyles from "../../Home.module.css";
import CTA from "../CTA/CTA";
import styles from "./CallToCTA.module.css";

type Props = DefaultProps & {
  keys: CallToCTAKeys;
};

export default function CallToCTA(props: Props) {
  const T = useT();
  const { params, keys } = props;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={UStyles.classNames(homeStyles.statement, styles.title)}>
          <span className={styles.iconBars}>
            <Icon2Bars />
          </span>
          {T(Globals.WAITLIST_ENABLED ? TKey.HOME_WAITLIST_FINAL_TITLE : keys.title)}
        </h2>
        <p className={styles.text}>
          {T(Globals.WAITLIST_ENABLED ? TKey.HOME_WAITLIST_FINAL_TEXT : keys.text)}
        </p>
      </div>

      <div className={styles.actions}>
        <CTA
          params={params}
          hideIcon
          min={false}
          action={HomeCtaAction.DEMO}
          ctaKey={TKey.HOME_CTA_BOOK_DEMO}
        />
        {!Globals.WAITLIST_ENABLED && (
          <Button
            params={params}
            text={T(TKey.HOME_CTA_START_FREE)}
            type={ButtonType.OUTLINE}
            isLink={false}
            min={false}
            onClick={() => ModalStore.getState().openSignUp(params)}
          />
        )}
      </div>
    </div>
  );
}
